import { createContext } from 'react';

export const ClockContext = createContext(
  {
    time: new Date(),
    color: '#840000',
    setColor: () => {},
    disco: false,
    setDisco: () => {},
  }
);